export default "__VITE_ASSET__DsCu730w__"